import axios from '@services/HTTP'
import { type PatientAPIData } from 'types/patient'

export const createPatient = async (userDetails: PatientAPIData, vendor: string) => {
  return axios.post<PatientAPIData & { questionnaire: string; vendor: string }, { patient: string }>('/patient', {
    ...userDetails,
    vendor
  })
}

export function isValidJWT(token: string) {
  if (!token) return
  const payload = atob(token.split('.')[1])
  const decoded = JSON.parse(payload.toString())
  return Date.now() + 5000 < decoded.exp * 1000
}
